var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsxs as _jsxs, jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { DogRecipeInfo } from '@content/products/meals';
import { PAGE_TYPE } from '@marketing/blog/types';
import { homepageFAQContent, ingredientsCarouselSectionContent, mealsPDPMealPromoContent, pdpHeroSectionContent, pricingContent, rtbWithImagesSectionContent, storeServePrepSectionContent, vetApprovedSectionContent, waysToNomContent, } from '@marketing/components/sections/content';
import PDPHeroSection from '@marketing/components/sections/heroes/PDP';
import FAQSection from '@marketing/components/sections/non_product/FAQ';
import Newsletter from '@marketing/components/sections/non_product/Newsletter';
import CostPerMealSection from '@marketing/components/sections/non_product/Pricing/CostPerMeal';
import RTBWithImagesSection from '@marketing/components/sections/non_product/RTB/RTBWithImages';
import RelatedArticlesSection from '@marketing/components/sections/non_product/RelatedArticles';
import IngredientsCarousel from '@marketing/components/sections/product/IngredientsCarousel';
import MealPromo from '@marketing/components/sections/product/MealPromo';
import StoreServePrepSection from '@marketing/components/sections/product/StoreServePrep';
import VetApprovedSection from '@marketing/components/sections/product/VetApproved';
import WaysToNomSection from '@marketing/components/sections/product/WaysToNom';
import NutritionFactsSection from '@marketing/components/sections/product/nutrition/NutritionFacts';
import { MealName } from '@marketing/content';
import { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { useLocation, useParams, useRouteLoaderData } from 'react-router';
import { sendGoogleTagManagerEvent } from '@trackers';
var RELATED_ARTICLES_PAGE_SIZE = 3;
var RELATED_ARTICLES_TAG = 'meals_related_articles';
var MealsProductPage = function () {
    var _a = useState({
        relatedArticles: [],
    }), relatedArticles = _a[0], setRelatedArticles = _a[1];
    var Butter = useRouteLoaderData('root').Butter;
    var recipeName = useParams().recipeName;
    var location = useLocation();
    useEffect(function () {
        sendGoogleTagManagerEvent({
            event: "view-".concat(recipeName),
        });
    }, [location.pathname]);
    useEffect(function () {
        var pageParams = {
            'alt_media_text': 1,
            'page_size': RELATED_ARTICLES_PAGE_SIZE,
            'fields.tags.tag_name': RELATED_ARTICLES_TAG,
        };
        Butter.page
            .list(PAGE_TYPE, pageParams)
            .then(function (response) {
            if (response.data) {
                var articles = { relatedArticles: response.data.data };
                setRelatedArticles(articles);
            }
        })
            .catch(function (error) {
            console.error('Error fetching related articles:', error);
        });
    }, []);
    if (!Object.values(MealName).includes(recipeName)) {
        throw new Error('Recipe not found');
    }
    var pdpHeroContent = pdpHeroSectionContent[recipeName];
    var ingredientsCarouselContent = ingredientsCarouselSectionContent[recipeName];
    var vetApprovedContent = vetApprovedSectionContent[recipeName];
    var mealPromoContent = mealsPDPMealPromoContent[recipeName];
    var displayName = DogRecipeInfo[recipeName].displayName;
    return (_jsxs(_Fragment, { children: [_jsxs(Helmet, { children: [_jsxs("title", { children: [displayName, " Dog Food | Nom Nom"] }), _jsx("meta", { name: "description", content: "Fresh ".concat(displayName, " dog food recipe formulated by top Board Certified Veterinary Nutritionists to provide your dog with healthy and delicious home cooked dog food, for more years together.") }), _jsx("link", { rel: "canonical", href: "https://nomnomnow.com/meals/".concat(recipeName) }), _jsx("script", __assign({ type: "application/ld+json" }, { children: JSON.stringify(DogRecipeInfo[recipeName].seoSchemaJson) }))] }), _jsxs("div", __assign({ className: "header-lining bg-surface-beige" }, { children: [_jsx(PDPHeroSection, { content: pdpHeroContent }), _jsx("div", __assign({ className: "md:border-t md:border-border-shoe" }, { children: _jsx(IngredientsCarousel, { content: ingredientsCarouselContent }) })), _jsx(NutritionFactsSection, { type: "recipe", productId: recipeName }), _jsx(VetApprovedSection, { content: vetApprovedContent }), _jsx(StoreServePrepSection, { content: storeServePrepSectionContent }), _jsx(RTBWithImagesSection, { backgroundColorStyle: "bg-surface-bacon", content: rtbWithImagesSectionContent }), _jsx(MealPromo, { content: mealPromoContent, backgroundColorStyle: "bg-surface-beige", stacked: false, pageName: "".concat(recipeName, "_pdp") }), _jsx(CostPerMealSection, { backgroundColorStyle: "bg-deco-dark-blue", content: pricingContent }), _jsx(FAQSection, { content: homepageFAQContent }), relatedArticles.relatedArticles && _jsx(RelatedArticlesSection, { content: relatedArticles }), _jsx(WaysToNomSection, { content: waysToNomContent }), _jsx(Newsletter, {})] }))] }));
};
export default MealsProductPage;
